import router from './index';
import utils from '@/util/index';
import store from '@/store/index';

//需要登录
router.beforeEach((to, from, next) => {
  if (to.meta.needLogin || to.matched[0].meta.needLogin) {
    if (
      (store.state.user.userId || store.state.userId) &&
      store.state.isLogin
    ) {
      next();
    } else {
      utils.tips('warning', '请您先登录');
      sessionStorage.clear();
      next('/login');
    }
  } else {
    next();
  }
});
